// PromotionalModal.js
import React from 'react';
import ReactDOM from 'react-dom';

const modalStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 10 
  },
  content: {
    width: "569px",
    height: "569px",
    backgroundColor: '#fff',
    position: 'relative'
  },
  closeButton: {
    position: 'absolute',
    top: '10px',
    right: '10px',
    background: 'transparent',
    border: 'none',
    fontSize: '24px',
    cursor: 'pointer'
  }
};

const PromotionalModal = ({ children, onClose }) => {
  // Close modal if clicking on the overlay
  const handleOverlayClick = () => {
    if (onClose) onClose();
  };

  // Prevent click events from propagating to the overlay
  const handleContentClick = (e) => {
    e.stopPropagation();
  };

  return ReactDOM.createPortal(
    <div style={modalStyles.overlay} onClick={handleOverlayClick}>
      <div style={modalStyles.content} onClick={handleContentClick}>
        <button style={modalStyles.closeButton} onClick={onClose}>×</button>
        {children}
      </div>
    </div>,
    document.getElementById('modal-root')
  );
};

export default PromotionalModal;
